function applyFilterChange({ state, type, name, property, value }) {
  const filters = state.navWithFilters.filters
    .map(filter => (filter.type === type && filter.name === name// match the appropriate filter by type
      ? { ...filter, [property]: value } // if march, override the property
      : filter
    ));
  return {
    ...state,
    navWithFilters: { ...state.navWithFilters, filters },
  };
}

export function openFilterSection({ state, action }) {
  return applyFilterChange({
    state,
    type: action.filterType,
    name: action.filterName,
    property: 'collapse',
    value: false,
  });
}

export function collapseFilterSection({ state, action }) {
  return applyFilterChange({
    state,
    type: action.filterType,
    name: action.filterName,
    property: 'collapse',
    value: true,
  });
}
